import { Clock, MoneyCircle, World } from '@js/web/components/icons';

export const fixedPriceAboutContent = {
  title: ['How it Works: Buy Now Marketplace'],
  body: [
    'The single largest trading card offering in the world. Items have asking prices and accept offers from prospective buyers. Sellers can list items from their Vault Portfolio at any time and all sales receive the same seller commission as our other marketplaces. It is free to list and the marketplace is active 24/7/365, so give it a try!'
  ],
  textSide: 'left',
  backgroundColor: 'white',
  imageUrlDesktop: jsConfig.links.imagesUrl + 'about-fixed-experience-desktop.png',
  imageUrlMobile: jsConfig.links.imagesUrl + 'about-fixed-experience-mobile.png',
  titleType: 'h1',
  overflowImage: false,
  noAssetBackground: true,
  containImage: true
}

export const fixedPriceFees = {
  title: 'Commission Example',
  hasBorderTop: true,
  smallTitle: true,
  priceSections: [
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$250</b></span></div>',
      label: 'Sale price',
    },
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$208 + 4%</b></span></div>',
      label: 'Seller receives a bonus commission + hammer amount',
    },
    {
      price: '<div class="d-flex flex-column justify-content-center align-items-center" style="min-height:54px"><span><b>$217</b></span></div>',
      label: 'Total seller commission received',
    },
  ],
  showSubmitButton: false
};

export const fixedPriceTripleIconMessages = [
  {
    icon: MoneyCircle,
    iconColor: '#FFF',
    iconBgColor: 'linear-gradient(125.54deg, #FF981F 6.67%, rgba(238, 146, 7, 0.3) 111.37%);',
    title: ['Free To List'],
    message: 'List items from a Vault Portfolio in seconds. Never any fees to list. Remove and edit listings at any time.'
  },
  {
    icon: Clock,
    iconColor: '#FFF',
    iconBgColor: 'linear-gradient(125.54deg, #FF981F 6.67%, rgba(238, 146, 7, 0.3) 111.37%);',
    title: ['24/7/365 Access'],
    message: 'This market never sleeps! Make purchases, list items, issue or receive offers/counteroffers at any time.'
  },
  {
    icon: World,
    iconColor: '#FFF',
    iconBgColor: 'linear-gradient(125.54deg, #FF981F 6.67%, rgba(238, 146, 7, 0.3) 111.37%);',
    title: ['World\'s Largest', 'Retail Marketplace'],
    message: 'The largest, most diverse assembly of trading cards available at any one time. From Cobb to Charizard, every genre and price range is well represented.'
  },
];

export const fixedDescription = {
  body: [
    '<p class="mb-0">Sellers make their Vault Portfolio items available for direct purchase. New items are added every day and items can be removed by sellers at any time, so act decisively! Items can be instantly purchased at any time for the price stated, or an offer of a lower amount can be submitted to sellers for their consideration. Offers last for 72 hours before automatically expiring, and sellers can counteroffer if they desire. Offers and counteroffers can proceed indefinitely until a deal is reached.</p>',
    '<p class="mb-4">Buyers need to register and log into their account (link) to gain unlimited access to the marketplaces. Track your offers seamlessly from the Fanatics Collect members portal and trade like a pro!</p>',
    '<p class="mb-0">Registered users must receive approval from Fanatics Collect staff to participate in a Monthly Premier Auction. Please hit the button below to request approval.</p>',
    '<p class="mb-0">Buyers are afforded free lifetime Fanatics Vault services on every purchase. Avoid costly shipping fees and sales taxes, too! All items, regardless of category or value, receive free Vault, free shipping, and zero sales tax.</p>',
    '<p class="mb-0">Unlike the auction marketplaces, all asking/offer amounts have the 20% buyer\'s premium already included in the total, so the amount you offer is the exact amount you will pay.</p>',
  ],
  title: 'Buying On The Buy Now Marketplace',
  darkButtonLink: jsConfig.links?.fixedUrl,
  darkButtonText: 'View Marketplace',
};
